import { Injectable } from "@angular/core";
import { Store } from "@karma-games/angular-devkit/src/lib/extended-store";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";

@Injectable({ providedIn: "root" })
export class GetLastStatisticsPageReachedUseCase implements IUseCase<void, boolean> {
    constructor(private store: Store) {
    }

    execute(): boolean {
        return this.store.selectStatisticsReachedLastPageFlag();
    }
}
